import { render, staticRenderFns } from "./cv-slider.vue?vue&type=template&id=d74efca8&"
import script from "./cv-slider.vue?vue&type=script&lang=js&"
export * from "./cv-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports